// link-meta.js
export function linkMetaPlugin(md) {
  // in-label: "Text | key=value | key=value"
  const parseLabel = (label) => {
    const parts = label.split("|").map(s => s.trim()).filter(Boolean);
    const text = parts.shift() ?? "";

    const attrs = {};
    for (const p of parts) {
      const m = p.match(/^([a-zA-Z0-9_-]+)\s*=\s*(.+)$/);
      if (!m) continue;
      let [, k, v] = m;
      v = v.trim();

      // Optional: Quotes entfernen
      if ((v.startsWith('"') && v.endsWith('"')) || (v.startsWith("'") && v.endsWith("'"))) {
        v = v.slice(1, -1);
      }

      attrs[k] = v;
    }
    return { text, attrs };
  };

  md.core.ruler.after("inline", "link_meta", (state) => {
    const tokens = state.tokens;

    for (const blockToken of tokens) {
      if (blockToken.type !== "inline" || !blockToken.children) continue;

      const children = blockToken.children;

      for (let i = 0; i < children.length; i++) {
        const t = children[i];
        if (t.type !== "link_open") continue;

        // Label sitzt typischerweise direkt nach link_open in children (als text)
        // Wir sammeln bis link_close, um auch Emphasis etc. robust zu behandeln.
        let j = i + 1;
        const labelTokens = [];
        while (j < children.length && children[j].type !== "link_close") {
          labelTokens.push(children[j]);
          j++;
        }
        if (j >= children.length) continue;

        // Nur anfassen, wenn Label reine Text-Tokens enthält (einfacher/robuster Start)
        const isPlainText = labelTokens.every(x => x.type === "text");
        if (!isPlainText) continue;

        const labelText = labelTokens.map(x => x.content).join("");
        if (!labelText.includes("|")) continue;

        const { text, attrs } = parseLabel(labelText);

        // Text ersetzen
        labelTokens.forEach((x, idx) => {
          x.content = idx === 0 ? text : "";
        });

        // Attribute setzen (Whitelist empfohlen)
        const allowed = new Set(["title", "target", "rel", "aria-label"]);
        for (const [k, v] of Object.entries(attrs)) {
          if (!allowed.has(k)) continue;
          t.attrSet(k, v);
        }

        // Sicherheitsstandard: target=_blank -> rel setzen, falls nicht vorhanden
        const target = t.attrGet("target");
        if (target === "_blank") {
          const rel = t.attrGet("rel");
          if (!rel) t.attrSet("rel", "noopener noreferrer");
        }

        // weiter nach dem link_close
        i = j;
      }
    }
  });
}